import { Link } from 'react-router-dom';

export default function ImpactCta() {
  return (
    <section className="py-16 bg-[#1A2332] text-white">
      <div className="container mx-auto px-4 text-center">
        <h2 style={{ fontFamily: 'Oswald, sans-serif' }} className="text-3xl sm:text-4xl font-bold mb-4">
          Your Next Car Can Save Lives
        </h2>
        <p className="text-base sm:text-xl text-white/90 mb-8 max-w-2xl mx-auto">
          Every vehicle purchase helps rescue dogs in the Pacific Northwest. 
          Shop our inventory and make a difference today.
        </p>

        <div className="flex flex-col sm:flex-row justify-center gap-3 px-4 sm:px-0">
          <Link
            to="/inventory"
            className="inline-flex items-center justify-center gap-2 bg-[#E8B84B] text-[#1A2332] px-8 py-4 rounded-lg font-semibold hover:bg-[#D4A43A] transition-colors whitespace-nowrap"
          >
            <i className="ri-car-line text-xl"></i>
            View Inventory
          </Link>
          <Link
            to="/contact"
            className="inline-flex items-center justify-center gap-2 bg-white/10 backdrop-blur-sm text-white border border-white/30 px-8 py-4 rounded-lg font-semibold hover:bg-white/20 transition-colors whitespace-nowrap"
          >
            <i className="ri-phone-line text-xl"></i>
            Contact Us
          </Link>
        </div>
      </div>
    </section>
  );
}